import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Well below' },
    { value: 2, label: 'Below' },
    { value: 3, label: 'At' },
    { value: 4, label: 'Above' },
    { value: 5, label: 'Well above' },
  ],
});
